import withQueryParams from './withQueryParams';

/* eslint-disable no-undef */

export let RequestMethod = /*#__PURE__*/function (RequestMethod) {
  RequestMethod["GET"] = "GET";
  RequestMethod["POST"] = "POST";
  RequestMethod["PUT"] = "PUT";
  RequestMethod["DELETE"] = "DELETE";
  RequestMethod["PATCH"] = "PATCH";
  RequestMethod["HEAD"] = "HEAD";
  return RequestMethod;
}({});
const DEFAULT_QUERY_ERROR = 'Something went wrong.';
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json'
};
/**
 * TODO: unit throttle functionality with that in the monolith
 */
export async function request(_ref) {
  let {
    url,
    method = RequestMethod.GET,
    authToken,
    headers,
    toJson = true,
    throwError = false,
    useDefaultHeaders = true,
    queryParams,
    ...rest
  } = _ref;
  const defaults = {
    method,
    ...(authToken && {
      credentials: 'include'
    }),
    headers: {
      ...(useDefaultHeaders && DEFAULT_HEADERS),
      ...(authToken && {
        Authorization: authToken
      }),
      ...headers
    },
    ...rest
  };
  let response = undefined;
  try {
    response = await globalThis?.fetch(withQueryParams(url, queryParams), {
      ...defaults
    });
    if (response.ok && response.status >= 200 && response.status < 300) {
      let data;
      // If response is empty (with 200 code) - it shouldn't have Content-type header
      if (toJson && response.status !== 204 && response.headers.get('Content-type')?.includes('json')) {
        data = await response.json();
      }
      return {
        data,
        error: undefined,
        response
      };
    }
  } catch (error) {
    if (throwError) {
      throw error || new Error(DEFAULT_QUERY_ERROR);
    }
    return {
      data: undefined,
      error: error || DEFAULT_QUERY_ERROR,
      response
    };
  }
  if (throwError) {
    throw new Error(DEFAULT_QUERY_ERROR);
  }
  return {
    data: undefined,
    error: DEFAULT_QUERY_ERROR,
    response
  };
}
//# sourceMappingURL=httpRequest.js.map